import { Component, OnInit, AfterViewInit, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { AuthService } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialUser } from 'angularx-social-login';
import { Customer } from '../transcation/transcation';
import { CustomerService } from '../transcation/transcation.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
// declare $ for Jquery Initialization
declare var $: any;
@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.css']
})
export class DemoComponent implements OnInit, AfterViewInit, OnChanges {
customers: any;
  totalValue = 0;

  user: SocialUser;
loggedIn: boolean;

 constructor(private authService: AuthService, private customerService: CustomerService) { }

 ngOnChanges(changes: SimpleChanges) {
   const dataChanges: SimpleChange = changes.customers;

   const customers: Customer[] = dataChanges.currentValue;
   this.totalValue = 0;
   customers.forEach(customer => {
     this.totalValue += customer.amount;
   });
 }




 ngOnInit() {
  this.authService.authState.subscribe((user) => {
    this.user = user;
    this.loggedIn = (user != null);
  });
  this.getCustomersList();
}

getCustomersList() {
  // Use snapshotChanges().map() to store the key
  this.customerService.getCustomersList().snapshotChanges().pipe(
    map(changes =>
      changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
    )
  ).subscribe(customers => {
    this.customers = customers;
  });
}

deleteCustomers() {
  this.customerService.deleteAll();
}

 signInWithGoogle(): void {
   this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
 }

 deleteCustomer() {
  this.customerService.deleteCustomer(this.customers.key);
}

 signInWithFB(): void {
   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
 }
 signInWithLinkedIn(): void {
   this.authService.signIn(LinkedInLoginProvider.PROVIDER_ID);
 }

 signOut(): void {
   this.authService.signOut();
 }

  ngAfterViewInit () {
    $(document).ready(function() {
      $('.sidenav').sidenav();
    });
    $(document).ready(function() {
      $('select').formSelect();
    });
    $(document).ready(function() {
      $('.datepicker').datepicker();
    });
}



}
